import React from 'react';
import Card from './_Card';

import './_CardContainer.scss';

const ImageLinks = (props) => {
    
    const { cardsData } = props;
    const { Card1 } = cardsData;
    const { Card2 } = cardsData;
    
    return (
        <div className="teach-card-container">
            <Card card={Card1} image={props.images.card1} backgroundColor='#00A5CF' index='0' slug="/competency/chess"/>
            <Card card={Card2} image={props.images.card2} backgroundColor='#FEBD00' index='1' slug="/competency/training"/>
        </div>
    )
}

export default ImageLinks;


// WEBPACK FOOTER //
// ./src/pages/competency/components/_CardContainer.js